import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import sidebarSlice from './sidebarSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sidebar: sidebarSlice,
  },
})
